/* eslint-disable no-unused-vars */
import { Divider } from 'antd';
import parser from 'html-react-parser';
import { useSelector } from 'react-redux';
import DokanOrderCard from '../card/DokanOrderCard';

function Summary({ singleOrderData }) {
    const { preferences } = useSelector((state) => state.preferences);
    return (
        <>
            <div>
                <DokanOrderCard hasTitle Title="Summary" hasDivider>
                    <div className="px-30px flex flex-col gap-6">
                        <div className="flex justify-between items-center">
                            <div className="text-light_gray font-semibold">Gross price</div>
                            <div className="font-bold">
                                {singleOrderData.total} {parser(preferences.currency_symbol || '')}
                            </div>
                        </div>
                        <div className="flex justify-between items-center">
                            <div className="text-light_gray font-normal">Total Discount</div>
                            <div className="font-bold">{singleOrderData.discount_total}</div>
                        </div>
                        <div className="flex justify-between items-center">
                            <div className="text-light_gray font-normal">Shipping</div>
                            <div className="font-bold">{singleOrderData.shipping_total}</div>
                        </div>
                    </div>
                    <Divider />
                    <div className="px-30px flex flex-col pb-6 gap-4">
                        <div className="flex justify-between items-center">
                            <div className="text-dark font-extrabold">Cart SubTotal</div>
                            <div className="font-bold">
                                {parseFloat(singleOrderData.total) +
                                    parseFloat(singleOrderData.discount_total) +
                                    parseFloat(singleOrderData.shipping_total)}
                                {parser(preferences.currency_symbol || '')}
                            </div>
                        </div>
                        <div className="flex justify-between items-center text-green">
                            <div className="font-extrabold">Earn From this Order</div>
                            <div className="font-bold"> </div>
                        </div>
                    </div>
                </DokanOrderCard>
            </div>
        </>
    );
}

export default Summary;
